import Rox from 'rox-browser';
import { getOS } from "@/helpers/getOs";

// import module flags permission
import { initFlagsHome } from "@/feature-flags/flags-home";
import { initFlagsWebinar } from "@/feature-flags/flags-webinar";

// const flags = {
//   testFlags: new Rox.Flag(true)
// };

// eslint-disable-next-line no-unused-vars
export async function initRollout() {
  const options = {  };

  // Register the flags
  initFlagsHome();
  initFlagsWebinar();
  // Rox.register('', flags);

  // Setup connection with the feature management environment key
  await Rox.setup(process.env.VUE_APP_ROLLOUT_KEY, options);

  Rox.setCustomStringProperty("user_operating_system", () => {
    return getOS();
  })
}
